import {
  Box,
  Button,
  HStack,
  IconButton,
  Select,
  Text,
  Textarea,
  VStack,
  useColorModeValue,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  ModalFooter,
  Tag,
  Tooltip,
  Input,
  Divider,
  Container,
  InputGroup,
  InputLeftElement,
  Icon,
  NumberDecrementStepper,
  NumberInputField,
  NumberInput,
  NumberInputStepper,
  NumberIncrementStepper,
  FormControl,
  FormLabel,
  Wrap,
  WrapItem,
} from "@chakra-ui/react";
import {
  FiMinimize,
  FiMaximize,
  FiSend,
  FiThermometer,
  FiDatabase,
  FiColumns,
  FiCloud,
  FiMessageSquare,
  FiGrid,
  FiImage,
  FiSettings,
  FiArrowDown,
  FiTool,
} from "react-icons/fi";
import { useTranslation } from "react-i18next";
import { ModelInfoModal } from "components/model-info/ModelInfoModal";
import { MdSlideshow } from "react-icons/md";
import { ImageSettingsModal } from "components/image-settings/ImageSettingsModal";
import {
  GenerateImageDecor8Request,
  IOutputFormat,
  TModelSearchResult,
  Agent,
} from "types";
import { chatAPI } from "services";
import { useEffect, useState } from "react";
interface ChatInputProps {
  selectedProvider: string;
  setSelectedProvider: (provider: string) => void;
  selectedModel: string;
  setSelectedModel: (model: string) => void;
  modelsByProvider: any;
  modelsByProviderForChat: any;
  modelsByProviderForVideo: any;
  modelsByProviderForImage: any;
  isExpanded: boolean;
  setIsExpanded: (expanded: boolean) => void;
  input: string;
  setInput: (input: string) => void;
  borderColor: string;
  providerSelectBg: string;
  onModelInfoOpen: () => void;
  onModelInfoClose: () => void;
  isModelInfoOpen: boolean;
  onImageModelSettingsOpen: () => void;
  onImageModelSettingsClose: () => void;
  isImageModelSettingsOpen: boolean;
  models: any;
  selectedModelBg: string;
  providers: any;
  handleSend: () => void;
  isLoading: boolean;
  error: string;
  temperature: number;
  setTemperature: (temperature: number) => void;
  showTempInput: boolean;
  setShowTempInput: (showTempInput: boolean) => void;
  memory: number;
  setMemory: (memory: number) => void;
  showMemoryInput: boolean;
  setShowMemoryInput: (showMemoryInput: boolean) => void;
  currencyPairs: any;
  currentSession: any;
  setSelectedNumChats: (numChats: number) => void;
  selectedProviders: string[];
  setSelectedProviders: (providers: string[]) => void;
  selectedModels: string[];
  setSelectedModels: (models: string[]) => void;
  selectedTemperatures: number[];
  setSelectedTemperatures: (temperatures: number[]) => void;
  selectedMemories: number[];
  setSelectedMemories: (memories: number[]) => void;
  embedModels: any;
  selectedEmbedModel: string;
  setSelectedEmbedModel: (embedModel: string) => void;
  showEmbedModelInput: boolean;
  setShowEmbedModelInput: (showEmbedModelInput: boolean) => void;
  providersForChat: any;
  providersForVideo: any;
  providersForImage: any;
  promptImage: string;
  setPromptImage: (promptImage: string) => void;
  lastPromptImage: string;
  setLastPromptImage: (lastPromptImage: string) => void;
  promptImageFile: string | null;
  setPromptImageFile: (promptImageFile: string | null) => void;
  numSlides: number;
  setNumSlides: (numSlides: number) => void;
  showNumSlides: boolean;
  setShowNumSlides: (showNumSlides: boolean) => void;
  slideTemplate: string;
  setSlideTemplate: (slideTemplate: string) => void;
  selectedRunwareModel: TModelSearchResult | null;
  setSelectedRunwareModel: (model: TModelSearchResult | null) => void;
  showNegativePrompt: boolean;
  setShowNegativePrompt: (showNegativePrompt: boolean) => void;
  negativePrompt: string;
  setNegativePrompt: (negativePrompt: string) => void;
  isHD: boolean;
  setIsHD: (isHD: boolean) => void;
  selectedSize: string;
  setSelectedSize: (selectedSize: string) => void;
  width: number;
  setWidth: (width: number) => void;
  height: number;
  setHeight: (height: number) => void;
  format: IOutputFormat;
  setFormat: (format: IOutputFormat) => void;
  numImages: number;
  setNumImages: (numImages: number) => void;
  steps: number;
  setSteps: (steps: number) => void;
  cfgScale: number;
  setCfgScale: (cfgScale: number) => void;
  scheduler: string;
  setScheduler: (scheduler: string) => void;
  seed: number;
  setSeed: (seed: number) => void;
  strength: number;
  setStrength: (strength: number) => void;
  decorType: "prime" | "stage";
  setDecorType: (decorType: "prime" | "stage") => void;
  roomType: GenerateImageDecor8Request["roomType"];
  setRoomType: (roomType: GenerateImageDecor8Request["roomType"]) => void;
  designStyle: GenerateImageDecor8Request["designStyle"];
  setDesignStyle: (
    designStyle: GenerateImageDecor8Request["designStyle"]
  ) => void;
  colorScheme: GenerateImageDecor8Request["colorScheme"];
  setColorScheme: (
    colorScheme: GenerateImageDecor8Request["colorScheme"]
  ) => void;
  specialityDecor: GenerateImageDecor8Request["specialityDecor"];
  setSpecialityDecor: (
    specialityDecor: GenerateImageDecor8Request["specialityDecor"]
  ) => void;
  scaleFactor: GenerateImageDecor8Request["scaleFactor"];
  setScaleFactor: (scaleFactor: number) => void;
  videoDuration: 5 | 10;
  setVideoDuration: (videoDuration: 5 | 10) => void;
  isMobile: boolean;
  handleScrollEndMessages: () => void;
  selectedAgent: string;
  setSelectedAgent: (selectedAgent: string) => void;
  agents: Agent[];
}

export const ChatInput = ({
  selectedProvider,
  setSelectedProvider,
  selectedModel,
  setSelectedModel,
  modelsByProvider,
  modelsByProviderForChat,
  modelsByProviderForVideo,
  modelsByProviderForImage,
  isExpanded,
  setIsExpanded,
  input,
  setInput,
  borderColor,
  providerSelectBg,
  onModelInfoOpen,
  onModelInfoClose,
  isModelInfoOpen,
  onImageModelSettingsOpen,
  onImageModelSettingsClose,
  isImageModelSettingsOpen,
  models,
  selectedModelBg,
  providers,
  handleSend,
  isLoading,
  error,
  temperature,
  setTemperature,
  showTempInput,
  setShowTempInput,
  memory,
  setMemory,
  showMemoryInput,
  setShowMemoryInput,
  currencyPairs,
  currentSession,
  setSelectedNumChats,
  selectedProviders,
  setSelectedProviders,
  selectedModels,
  setSelectedModels,
  selectedTemperatures,
  setSelectedTemperatures,
  selectedMemories,
  setSelectedMemories,
  embedModels,
  selectedEmbedModel,
  setSelectedEmbedModel,
  showEmbedModelInput,
  setShowEmbedModelInput,
  providersForChat,
  providersForVideo,
  providersForImage,
  promptImage,
  setPromptImage,
  lastPromptImage,
  setLastPromptImage,
  promptImageFile,
  setPromptImageFile,
  numSlides,
  setNumSlides,
  showNumSlides,
  setShowNumSlides,
  slideTemplate,
  setSlideTemplate,
  selectedRunwareModel,
  setSelectedRunwareModel,
  showNegativePrompt,
  setShowNegativePrompt,
  negativePrompt,
  setNegativePrompt,
  isHD,
  setIsHD,
  selectedSize,
  setSelectedSize,
  width,
  setWidth,
  height,
  setHeight,
  format,
  setFormat,
  numImages,
  setNumImages,
  steps,
  setSteps,
  cfgScale,
  setCfgScale,
  scheduler,
  setScheduler,
  seed,
  setSeed,
  strength,
  setStrength,
  decorType,
  setDecorType,
  roomType,
  setRoomType,
  designStyle,
  setDesignStyle,
  colorScheme,
  setColorScheme,
  specialityDecor,
  setSpecialityDecor,
  scaleFactor,
  setScaleFactor,
  isMobile,
  handleScrollEndMessages,
  videoDuration,
  setVideoDuration,
  selectedAgent,
  setSelectedAgent,
  agents,
}: ChatInputProps) => {
  const { t } = useTranslation();
  const [activeAgent, setActiveAgent] = useState<string | null>(null);
  useEffect(() => {
    const findAgent = async () => {
      const agentId = await findAgentBySessionName(currentSession?.id);
      setActiveAgent(agentId);
    };
    findAgent();
  }, [currentSession]);
  const fileToBase64 = (file: File) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.onerror = reject;
      reader.readAsDataURL(file);
    });
  };

  const compressImage = async (file: File): Promise<Blob> => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = (event) => {
        const img = new Image();
        img.onload = () => {
          const canvas = document.createElement("canvas");
          let width = img.width;
          let height = img.height;

          // Calculate new dimensions while maintaining aspect ratio
          const maxDimension = 512; // Max width/height
          if (width > height && width > maxDimension) {
            height = (height * maxDimension) / width;
            width = maxDimension;
          } else if (height > maxDimension) {
            width = (width * maxDimension) / height;
            height = maxDimension;
          }

          canvas.width = width;
          canvas.height = height;

          const ctx = canvas.getContext("2d");
          ctx?.drawImage(img, 0, 0, width, height);

          // Convert to blob with reduced quality
          canvas.toBlob(
            (blob) => {
              if (blob) {
                resolve(blob);
              } else {
                reject(new Error("Canvas to Blob conversion failed"));
              }
            },
            "image/jpeg",
            0.7 // Compression quality (0-1)
          );
        };
        img.src = event.target?.result as string;
      };
      reader.onerror = reject;
      reader.readAsDataURL(file);
    });
  };

  const findAgentBySessionName = async (sessionId: string) => {
    const sessions = await chatAPI.getSessions();
    const session = sessions.find((s: any) => s.id === sessionId);
    // Extract agent name by removing the UID portion after " - "
    const agentNameSplit = session?.sessionName?.split(" - ")[0];
    if (agentNameSplit) {
      const agent = agents.find((a) => a.name === agentNameSplit);
      if (agent) {
        return agent.id;
      }
    }
    return null;
  };

  // Get the current model's enabled status
  const isModelEnabled =
    models.find((m: any) => m.id === selectedModel)?.enabled ?? false;

  const isModelGeneration =
    models.find((m: any) => m.id === selectedModel)?.type === "generation";

  const isModelChat =
    models.find((m: any) => m.id === selectedModel)?.type === "llm" &&
    models
      .find((m: any) => m.id === selectedModel)
      ?.capabilities?.includes("chat");

  const chatBg = useColorModeValue(
    "rgba(255, 255, 255, 0.43)",
    "rgba(0, 0, 0, 0.47)"
  );
  // TODO: We need to completely refactor the provider/model selection to work across all session types flawlessly, plus it needs to be VERY easy to use
  return (
    <Box
      p={2}
      borderTop="1px"
      borderRadius="2xl"
      borderColor={borderColor}
      position="fixed"
      bottom={0}
      w={isMobile ? "100%" : "90%"}
      left={isMobile ? 0 : "5%"}
      right={isMobile ? 0 : "5%"}
      bg={chatBg}
      backdropFilter="blur(20px)"
    >
      <Box
        position="absolute"
        bottom={120}
        right={0}
        left={0}
        display="flex"
        justifyContent="center"
        alignItems="center"
      >
        <Button
          aria-label="Scroll to top"
          leftIcon={<FiArrowDown />}
          bg="rgba(0, 0, 0, 0.5)"
          color="white"
          backdropFilter="blur(10px)"
          onClick={handleScrollEndMessages}
        >
          {t("common.scrollToBottom")}
        </Button>
      </Box>

      <VStack spacing={2} align="stretch">
        {/* Model Selection */}
        {(currentSession?.sessionType === "STANDARD" ||
          currentSession?.sessionType === "PRESENTATION" ||
          currentSession?.sessionType === "IMAGE_CHAT") && (
          <HStack spacing={2}>
            <Tooltip
              label={t("chat.modelSelect.providerHelpText")}
              placement="top"
              hasArrow
            >
              <Select
                value={selectedProvider}
                icon={<FiCloud />}
                onChange={(e) => {
                  setSelectedProvider(e.target.value);
                  if (
                    !modelsByProvider[e.target.value]?.find(
                      (m: any) => m.id === selectedModel
                    )
                  ) {
                    setSelectedModel(
                      modelsByProvider[e.target.value]?.[0]?.id || ""
                    );
                  }
                }}
                size="sm"
                maxW={{ base: "50px", md: "120px" }}
                variant="filled"
                bg={providerSelectBg}
              >
                {(currentSession?.sessionType === "STANDARD" ||
                  currentSession?.sessionType === "PRESENTATION") &&
                  providersForChat.map((provider: any) => (
                    <option key={provider} value={provider}>
                      {provider}
                    </option>
                  ))}
                {currentSession?.sessionType === "IMAGE_CHAT" &&
                  providersForImage.map((provider: any) => (
                    <option key={provider} value={provider}>
                      {provider}
                    </option>
                  ))}
              </Select>
            </Tooltip>
            <HStack spacing={1}>
              {/* Model Selection */}
              <Tooltip
                label={t("chat.modelSelect.modelHelpText")}
                placement="top"
                hasArrow
              >
                <Select
                  icon={<FiMessageSquare />}
                  value={selectedModel}
                  onChange={(e) => setSelectedModel(e.target.value)}
                  size="sm"
                  maxW={{ base: "50px", md: "120px" }}
                  variant="filled"
                  bg={providerSelectBg}
                >
                  {(currentSession?.sessionType === "STANDARD" ||
                    currentSession?.sessionType === "PRESENTATION") &&
                    modelsByProviderForChat[selectedProvider]?.map(
                      (model: any) => (
                        <option
                          key={model.id}
                          value={model.id}
                          disabled={!model.enabled}
                        >
                          {model.name} {!model.enabled && "(Disabled)"}
                        </option>
                      )
                    )}
                  {currentSession?.sessionType === "IMAGE_CHAT" &&
                    modelsByProviderForImage[selectedProvider]?.map(
                      (model: any) => (
                        <option
                          key={model.id}
                          value={model.id}
                          disabled={!model.enabled}
                        >
                          {model.name} {!model.enabled && "(Disabled)"}
                        </option>
                      )
                    )}
                </Select>
              </Tooltip>
              {/* Model Info */}
              <Tooltip
                label={t("chat.modelInfo.helpText")}
                placement="top"
                hasArrow
              >
                <IconButton
                  aria-label={t("chat.modelInfo.helpText")}
                  icon={<FiGrid />}
                  size="sm"
                  variant="ghost"
                  onClick={onModelInfoOpen}
                />
              </Tooltip>
              {/* Temperature */}
              {currentSession?.sessionType !== "IMAGE_CHAT" && (
                <HStack>
                  <Tooltip
                    label={t("chat.temperature.helpText")}
                    placement="top"
                    hasArrow
                  >
                    <IconButton
                      aria-label={t("chat.temperature.helpText")}
                      icon={<FiThermometer />}
                      size="sm"
                      variant="ghost"
                      onClick={() => setShowTempInput(!showTempInput)}
                    />
                  </Tooltip>
                  {showTempInput && (
                    <Input
                      size="sm"
                      width="60px"
                      value={temperature}
                      type="number"
                      min={0}
                      max={2}
                      step={0.1}
                      onChange={(e) => {
                        const value = parseFloat(e.target.value);
                        if (!isNaN(value) && value >= 0 && value <= 2) {
                          setTemperature(value);
                        }
                      }}
                      // onBlur={() => setShowTempInput(false)}
                    />
                  )}
                </HStack>
              )}
              {/* Memory */}
              {currentSession?.sessionType !== "PRESENTATION" &&
                currentSession?.sessionType !== "IMAGE_CHAT" && (
                  <HStack>
                    <Tooltip
                      label={t("chat.memory.helpText")}
                      placement="top"
                      hasArrow
                    >
                      <IconButton
                        aria-label={t("chat.memory.helpText")}
                        icon={<FiDatabase />}
                        size="sm"
                        variant="ghost"
                        onClick={() => setShowMemoryInput(!showMemoryInput)}
                      />
                    </Tooltip>
                    {showMemoryInput && (
                      <Input
                        size="sm"
                        width="60px"
                        value={memory}
                        type="number"
                        min={0}
                        max={1000}
                        step={1}
                        onChange={(e) => {
                          const value = parseInt(e.target.value);
                          if (!isNaN(value) && value >= 0 && value <= 1000) {
                            setMemory(value);
                          }
                        }}
                        // onBlur={() => setShowMemoryInput(false)}
                      />
                    )}
                  </HStack>
                )}
              {/* TODO: Embed Model */}
              {/* <HStack>
                <Tooltip
                  label={t("chat.embedModel.helpText")}
                  placement="top"
                  hasArrow
                >
                  <IconButton
                    aria-label={t("chat.embedModel.helpText")}
                    icon={<MdDataArray />}
                    size="sm"
                    variant="ghost"
                    onClick={() => setShowEmbedModelInput(!showEmbedModelInput)}
                  />
                </Tooltip>
                {showEmbedModelInput && (
                  <InputGroup size="md">
                    <Select
                      icon={<MdDataArray />}
                      size="sm"
                      maxW={{ base: "50px", md: "120px" }}
                      variant="filled"
                      bg={providerSelectBg}
                      value={selectedEmbedModel}
                      onChange={(e) => {
                        setSelectedEmbedModel(e.target.value);
                      }}
                    >
                      {embedModels?.map((model: any) => (
                        <option key={model.id} value={model.id}>
                          {model.provider} - {model.name}
                        </option>
                      ))}
                    </Select>
                  </InputGroup>
                )}
              </HStack> */}
              {currentSession?.sessionType === "IMAGE_CHAT" && (
                <HStack>
                  <Tooltip
                    label={t("chat.imageSettings.helpText")}
                    placement="top"
                    hasArrow
                  >
                    <IconButton
                      aria-label={t("chat.imageSettings.helpText")}
                      icon={<FiSettings />}
                      size="sm"
                      variant="ghost"
                      onClick={onImageModelSettingsOpen}
                    />
                  </Tooltip>

                  {currentSession?.sessionType === "IMAGE_CHAT" &&
                    selectedModel.includes("decor8") && (
                      <FormControl>
                        {/* <FormLabel>{t("chat.imageSettings.uploadImage")}</FormLabel> */}
                        {/* <Box
                  border="2px dashed"
                  borderColor="gray.300"
                  borderRadius="md"
                  p={4}
                  textAlign="center"
                  // bg={inputBg}
                  _hover={{ borderColor: "gray.400" }}
                  cursor="pointer"
                  onDrop={(e) => {
                    e.preventDefault();
                    const file = e.dataTransfer?.files[0];
                    if (file) {
                      // Handle file upload
                      console.log(file);
                    }
                  }}
                  onDragOver={(e) => e.preventDefault()}
                >
                  <Text>{t("chat.imageSettings.dragAndDrop")}</Text>
                </Box> */}
                        <Input
                          type="url"
                          value={promptImage}
                          onChange={(e) => setPromptImage(e.target.value)}
                          placeholder={t("chat.imageSettings.imageUrl")}
                        />
                      </FormControl>
                    )}
                </HStack>
              )}
              {/* Number of Slides */}
              {currentSession?.sessionType === "PRESENTATION" && (
                <HStack>
                  <Tooltip
                    label={t("chat.slides.helpText")}
                    placement="top"
                    hasArrow
                  >
                    <IconButton
                      aria-label={t("chat.slides.helpText")}
                      icon={<MdSlideshow />}
                      size="sm"
                      variant="ghost"
                      onClick={() => setShowNumSlides(!showNumSlides)}
                    />
                  </Tooltip>
                  {showNumSlides && (
                    <>
                      <Tooltip
                        label={t("chat.slides.numSlides")}
                        placement="top"
                        hasArrow
                      >
                        <NumberInput
                          size="sm"
                          width="120px"
                          value={numSlides}
                          min={1}
                          max={10}
                          step={1}
                          onChange={(valueString) => {
                            const value = parseInt(valueString);
                            if (!isNaN(value) && value >= 1 && value <= 10) {
                              setNumSlides(value);
                            } else {
                              setNumSlides(1);
                            }
                          }}
                          // onBlur={() => setShowNumSlides(false)}
                        >
                          <NumberInputField />
                          <NumberInputStepper>
                            <NumberIncrementStepper />
                            <NumberDecrementStepper />
                          </NumberInputStepper>
                        </NumberInput>
                      </Tooltip>
                      <Tooltip
                        label={t("chat.slides.template")}
                        placement="top"
                        hasArrow
                      >
                        <Select
                          value={slideTemplate}
                          size="sm"
                          onChange={(e) => setSlideTemplate(e.target.value)}
                        >
                          <option value="modern">Modern</option>
                          <option value="classic">Classic</option>
                          <option value="minimal">Minimal</option>
                          <option value="gradient">Gradient</option>
                        </Select>
                      </Tooltip>
                    </>
                  )}
                </HStack>
              )}
            </HStack>
          </HStack>
        )}

        {/* Comparative Chat */}
        {currentSession?.sessionType === "COMPARATIVE_CHAT" && (
          <HStack spacing={2}>
            {/* // Select number of chats */}
            <Tooltip label={t("chat.numChats.select")} placement="top" hasArrow>
              <Select
                value={currentSession.indexes}
                onChange={(e) => setSelectedNumChats(parseInt(e.target.value))}
                icon={<FiColumns />}
                size="sm"
                maxW="60px"
                variant="filled"
                bg={providerSelectBg}
              >
                <option value="2" disabled={currentSession.indexes === 2}>
                  2
                </option>
                <option value="3" disabled={currentSession.indexes === 3}>
                  3
                </option>
                <option value="4" disabled={currentSession.indexes === 4}>
                  4
                </option>
              </Select>
            </Tooltip>

            {/* // Here we have X groups with select for provider, model, temperature, setMemory */}
            <Box display="flex" overflowX="auto">
              {Array.from({ length: currentSession.indexes }, (_, index) => (
                <HStack
                  key={index}
                  p={1}
                  borderRadius="md"
                  spacing={2}
                  bg={chatBg}
                  mr={2}
                >
                  <Tag size="sm" p={1}>
                    #{index + 1}
                  </Tag>
                  <InputGroup size="md">
                    <Select
                      icon={<FiCloud />}
                      value={selectedProviders[index] || selectedProvider}
                      minWidth="100px"
                      onChange={(e) => {
                        const newProviders = [...selectedProviders];
                        newProviders[index] = e.target.value;
                        setSelectedProviders(newProviders);
                      }}
                    >
                      {providersForChat.map((provider: any) => (
                        <option key={provider} value={provider}>
                          {provider}
                        </option>
                      ))}
                    </Select>
                  </InputGroup>
                  <InputGroup size="md">
                    <Select
                      icon={<FiMessageSquare />}
                      minWidth="100px"
                      value={selectedModels[index] || selectedModel}
                      onChange={(e) => {
                        const newModels = [...selectedModels];
                        newModels[index] = e.target.value;
                        setSelectedModels(newModels);
                      }}
                    >
                      {modelsByProviderForChat[
                        selectedProviders[index] || selectedProvider
                      ]?.map((model: any) => (
                        <option key={model.id} value={model.id}>
                          {model.name}
                        </option>
                      ))}
                    </Select>
                  </InputGroup>
                  <InputGroup size="md">
                    <InputLeftElement>
                      <Icon as={FiThermometer} />
                    </InputLeftElement>
                    <Input
                      value={selectedTemperatures[index] || temperature}
                      type="number"
                      minWidth="80px"
                      min={0}
                      max={2}
                      step={0.1}
                      onChange={(e) => {
                        const newTemperatures = [...selectedTemperatures];
                        newTemperatures[index] = parseFloat(e.target.value);
                        setSelectedTemperatures(newTemperatures);
                      }}
                    />
                  </InputGroup>
                  <InputGroup size="md">
                    <InputLeftElement>
                      <Icon as={FiDatabase} />
                    </InputLeftElement>
                    <Input
                      value={selectedMemories[index] || memory}
                      type="number"
                      minWidth="80px"
                      min={0}
                      max={1000}
                      step={1}
                      onChange={(e) => {
                        const newMemories = [...selectedMemories];
                        newMemories[index] = parseInt(e.target.value);
                        setSelectedMemories(newMemories);
                      }}
                    />
                  </InputGroup>

                  {/* <Text>
                    {JSON.stringify(selectedTemperatures)}
                    {JSON.stringify(selectedMemories)}
                    {JSON.stringify(selectedProviders)}
                    {JSON.stringify(selectedModels)}
                  </Text> */}
                </HStack>
              ))}
            </Box>
          </HStack>
        )}

        {/* Agent Chat */}
        {currentSession?.sessionType === "AGENT_CHAT" && (
          <HStack spacing={2}>
            <Tooltip
              label={t("chat.agentChat.helpText")}
              placement="top"
              hasArrow
            >
              {/* <Text>{JSON.stringify(selectedAgent)}</Text> */}
              <Select
                value={selectedAgent || ""}
                onChange={(e) => setSelectedAgent(e.target.value)}
              >
                <option value="" selected>
                  {t("chat.agentChat.changeAgent")}
                </option>
                {agents.map((agent: Agent) => (
                  <option key={agent.id} value={agent.id}>
                    {agent.name}
                  </option>
                ))}
              </Select>
            </Tooltip>
            <Wrap spacing={1}>
              {agents
                .find((agent: Agent) => agent.id === selectedAgent)
                ?.tools.map((tool: string) => (
                  <WrapItem key={tool}>
                    <Tooltip
                      label={tool.includes("-") ? tool.split("-")[0] : tool}
                      placement="top"
                      hasArrow
                      key={tool}
                    >
                      <IconButton
                        aria-label={tool}
                        icon={<FiTool />}
                        size="sm"
                        variant="ghost"
                      />
                    </Tooltip>
                  </WrapItem>
                ))}
            </Wrap>
          </HStack>
        )}

        {/* {currentSession?.sessionType === "IMAGE_CHAT" && (
          <HStack spacing={2}>
            <InputGroup size="md">
              <InputLeftElement>
                <Icon as={FiImage} />
              </InputLeftElement>
              <Input type="file" accept="image/*" />
            </InputGroup>
          </HStack>
        )} */}

        {currentSession?.sessionType === "VIDEO_CHAT" && (
          <HStack spacing={2}>
            <Select
              value={selectedProvider}
              icon={<FiCloud />}
              onChange={(e) => {
                setSelectedProvider(e.target.value);
                if (
                  !modelsByProvider[e.target.value]?.find(
                    (m: any) => m.id === selectedModel
                  )
                ) {
                  setSelectedModel(
                    modelsByProvider[e.target.value]?.[0]?.id || ""
                  );
                }
              }}
              size="sm"
              maxW={{ base: "50px", md: "120px" }}
              variant="filled"
              bg={providerSelectBg}
            >
              {providersForVideo.map((provider: any) => (
                <option key={provider} value={provider}>
                  {provider}
                </option>
              ))}
            </Select>
            <Select
              icon={<FiMessageSquare />}
              value={selectedModel}
              onChange={(e) => setSelectedModel(e.target.value)}
              size="sm"
              maxW={{ base: "50px", md: "120px" }}
              variant="filled"
              bg={providerSelectBg}
            >
              {modelsByProviderForVideo[selectedProvider]?.map((model: any) => (
                <option
                  key={model.id}
                  value={model.id}
                  disabled={!model.enabled}
                >
                  {model.name} {!model.enabled && "(Disabled)"}
                </option>
              ))}
            </Select>
            <Tooltip
              label={t("chat.modelInfo.helpText")}
              placement="top"
              hasArrow
            >
              <IconButton
                aria-label={t("chat.modelInfo.helpText")}
                icon={<FiGrid />}
                size="sm"
                variant="ghost"
                onClick={onModelInfoOpen}
              />
            </Tooltip>
            <InputGroup size="md">
              <InputLeftElement>
                <Icon as={FiImage} />
              </InputLeftElement>
              <Input
                type="url"
                value={promptImage}
                onChange={(e) => setPromptImage(e.target.value)}
                placeholder="Enter first image URL"
              />
            </InputGroup>
            <InputGroup size="md">
              <InputLeftElement>
                <Icon as={FiImage} />
              </InputLeftElement>
              <Input
                type="url"
                value={lastPromptImage}
                onChange={(e) => setLastPromptImage(e.target.value)}
                placeholder="Enter last image URL"
              />
            </InputGroup>
            <Tooltip
              label={t("chat.videoDuration.helpText")}
              placement="top"
              hasArrow
            >
              <Select
                value={videoDuration}
                onChange={(e) =>
                  setVideoDuration(parseInt(e.target.value) as 5 | 10)
                }
              >
                <option value="5">5 seconds</option>
                <option value="10">10 seconds</option>
              </Select>
            </Tooltip>
          </HStack>
        )}

        {/* Model Info Modal */}
        <ModelInfoModal
          isOpen={isModelInfoOpen}
          onClose={onModelInfoClose}
          models={models}
          isLoading={isLoading}
          isModelInfoOpen={isModelInfoOpen}
          onModelInfoClose={onModelInfoClose}
          currencyPairs={currencyPairs}
          defaultProvider={selectedProvider}
        />
        <ImageSettingsModal
          selectedModel={selectedModel}
          isOpen={isImageModelSettingsOpen}
          onClose={onImageModelSettingsClose}
          isLoading={isLoading}
          isImageSettingsOpen={isImageModelSettingsOpen}
          onImageSettingsClose={onImageModelSettingsClose}
          showNegativePrompt={showNegativePrompt}
          setShowNegativePrompt={setShowNegativePrompt}
          negativePrompt={negativePrompt}
          setNegativePrompt={setNegativePrompt}
          isHD={isHD}
          setIsHD={setIsHD}
          selectedSize={selectedSize}
          setSelectedSize={setSelectedSize}
          width={width}
          setWidth={setWidth}
          height={height}
          setHeight={setHeight}
          format={format}
          setFormat={setFormat}
          numImages={numImages}
          setNumImages={setNumImages}
          steps={steps}
          setSteps={setSteps}
          cfgScale={cfgScale}
          setCfgScale={setCfgScale}
          scheduler={scheduler}
          setScheduler={setScheduler}
          seed={seed}
          setSeed={setSeed}
          strength={strength}
          setStrength={setStrength}
          promptImageFile={promptImageFile}
          decorType={decorType}
          setDecorType={setDecorType}
          roomType={roomType}
          setRoomType={setRoomType}
          designStyle={designStyle}
          setDesignStyle={setDesignStyle}
          colorScheme={colorScheme}
          setColorScheme={setColorScheme}
          specialityDecor={specialityDecor}
          setSpecialityDecor={setSpecialityDecor}
          scaleFactor={scaleFactor}
          setScaleFactor={setScaleFactor}
          selectedRunwareModel={selectedRunwareModel}
          setSelectedRunwareModel={setSelectedRunwareModel}
          currentSession={currentSession}
          setPromptImageFile={setPromptImageFile}
          compressImage={compressImage}
          fileToBase64={fileToBase64}
        />
        {/* <Text>
          {JSON.stringify(selectedProvider)}
          {JSON.stringify(selectedModel)}
        </Text> */}

        {/* Message Input */}
        <HStack spacing={2} align="end">
          <Box position="relative" w="full">
            <IconButton
              icon={isExpanded ? <FiMinimize /> : <FiMaximize />}
              aria-label={isExpanded ? t("chat.collapse") : t("chat.expand")}
              size="sm"
              position="absolute"
              bottom={2}
              right={2}
              variant="ghost"
              onClick={() => setIsExpanded(!isExpanded)}
              zIndex={2}
              bg={useColorModeValue("white", "gray.800")}
              _hover={{
                bg: useColorModeValue("gray.100", "gray.700"),
              }}
            />

            {/* <Text>
              {JSON.stringify(selectedProvider)}
              {JSON.stringify(selectedModel)}
            </Text> */}
            <Textarea
              value={input}
              onChange={(e) => setInput(e.target.value)}
              onKeyDown={(e) => {
                if (
                  e.key === "Enter" &&
                  !e.shiftKey &&
                  isModelEnabled &&
                  !isLoading
                ) {
                  e.preventDefault();
                  handleSend();
                }
              }}
              placeholder={t("chat.placeholder")}
              size="lg"
              disabled={
                isLoading ||
                (currentSession?.sessionType === "IMAGE_CHAT" &&
                  selectedModel.includes("decor8"))
              }
              minH="52px"
              h={isExpanded ? "50vh" : "auto"}
              maxH={isExpanded ? "50vh" : "300px"}
              resize="none"
              rows={1}
              overflow="auto"
              transition="height 0.2s"
              _focus={{
                boxShadow: "none",
                borderColor: "brand.primary",
              }}
              sx={{
                "&::-webkit-scrollbar": {
                  width: "8px",
                  borderRadius: "8px",
                  backgroundColor: `rgba(0, 0, 0, 0.05)`,
                },
                "&::-webkit-scrollbar-thumb": {
                  backgroundColor: `rgba(0, 0, 0, 0.1)`,
                  borderRadius: "8px",
                },
              }}
              position="relative"
              zIndex={1}
            />
          </Box>
          <IconButton
            aria-label={t("chat.sendMessage")}
            icon={<FiSend />}
            onClick={handleSend}
            isLoading={isLoading}
            isDisabled={!isModelEnabled || isLoading}
            size="lg"
            alignSelf={isExpanded ? "start" : "end"}
          />
        </HStack>
      </VStack>
      {error && (
        <Text color="red.500" mt={2} fontSize="sm">
          {error}
        </Text>
      )}
    </Box>
  );
};
